import { Card, CardContent } from "@material-ui/core";
import React, { Component } from "react";
import { Spinner, Button } from "react-bootstrap";
import SemuaPT from "./Display/pt/SemuaPT";
import MahasiswaPT from "./Display/pt/MahasiswaPT";
import DosenPT from "./Display/pt/DosenPT";
// import PengabdianPT from "./Display/pt/PengabdianPT";
import axios from "axios";
import AppConfig from "../../config/AppConfig";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { LinearProgress } from "@material-ui/core";
const bgImage = toAbsoluteUrl("/media/bg/bg-10.jpg");

class PT extends Component {
  constructor(props, context) {
    super(props, context);
  }
  state = {
    menu: "1",
    name: "",
    display: false,
    dataProd: [],
    id_sms: "",
    name_sms: "",
    displayProdi: false,
    resetProdi: false,
    loadingProdi: false,
    loadingSearch: false,
    menu_display: true,
    name_sp: "",
    data_profile: [],
  };

  componentDidMount() {
    console.log("id_sp : ", this.props);
    if (this.props.id_sp !== undefined) {
      this.setState({
        menu_display: false,
        id_sp: this.props.id_sp,
      });
      let data = AppConfig.Profile + "/" + this.props.id_sp;
      let rq = axios.get(data);
      axios
        .all([rq])
        .then(
          axios.spread((...responses) => {
            let response = responses[0];

            this.setState({
              data_profile: response.data?.result?.profile,
              name_sp: response.data?.result?.profile?.nm_lemb,
              menu_display: true,
            });
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
    }
  }

  onChangeMenu = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
    this.setState({
      id_sms: "",
      name_sms: "",
      displayProdi: false,
      display: false,
      resetProdi: true,
    });
  };
  onChangeProdi = (e) => {
    this.setState({
      name_sms: e.target.value,
    });
    if (e.target.value.length > 2) {
      this.setState({
        display: false,
        loadingProdi: true,
      });
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let id_institusi = localStorage.getItem("id_sp_temp");
      let id_sp = sessiondata.i_idunit;
      if (this.props.id_sp !== undefined) {
        id_sp = this.props.id_sp;
      } else {
        id_sp = sessiondata.i_idunit;
      }
      let session = "";
      if (id_institusi !== "") {
        if (this.props.id_sp !== undefined) {
          session = "?id_sp=" + this.props.id_sp;
        } else {
          session = "?id_sp=" + id_institusi;
        }
      }
      if (id_institusi === null) {
        id_sp = sessiondata.i_idunit;
      }
      let data_prodi = AppConfig.ProdiByPT + session;

      var formData = new FormData();
      formData.append("id_sp", id_sp);
      formData.append("keyword", e.target.value);

      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      axios
        .post(data_prodi, formData)
        .then((res) => {
          if (res.status === 200) {
          }
          this.setState({
            dataProd: res.data?.result?.prodi,
            display: true,
            loadingProdi: false,
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    } else {
      this.setState({
        display: false,
      });
    }
  };
  onClickSelectProdi = (id_sms, name_sms) => {
    this.setState({
      id_sms: id_sms,
      name_sms: name_sms,
      display: false,
    });
  };
  onClickResetProdi = (e) => {
    this.setState({
      id_sms: "",
      name_sms: "",
      displayProdi: false,
      display: false,
      resetProdi: true,
    });
  };

  onClickSearchProdi = (e) => {
    this.setState({
      displayProdi: true,
      resetProdi: false,
      loadingSearch: true,
    });
  };
  handleCallbackDisplayProdi = (childData) => {
    this.setState({ displayProdi: childData });
  };
  handleCallbackResetProdi = (childData) => {
    this.setState({ resetProdi: childData });
  };
  handleCallbackSearch = (childData) => {
    this.setState({ loadingSearch: childData });
  };
  render() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let display_data = [];
    let { menu } = this.state;
    if (this.state.menu_display === true) {
      if (menu === "1") {
        display_data = (
          <SemuaPT
            idSms={this.state.id_sms}
            profile_pt={this.state.data_profile}
            idSp={this.state.id_sp}
            displayProdi={this.state.displayProdi}
            resetProdi={this.state.resetProdi}
            handleCallbackDisplayProdi={this.handleCallbackDisplayProdi}
            handleCallbackResetProdi={this.handleCallbackResetProdi}
            handleCallbackSearch={this.handleCallbackSearch}
          />
        );
      } else if (menu === "2") {
        display_data = (
          <MahasiswaPT
            idSms={this.state.id_sms}
            idSp={this.state.id_sp}
            displayProdi={this.state.displayProdi}
            resetProdi={this.state.resetProdi}
            handleCallbackDisplayProdi={this.handleCallbackDisplayProdi}
            handleCallbackResetProdi={this.handleCallbackResetProdi}
            handleCallbackSearch={this.handleCallbackSearch}
          />
        );
      } else if (menu === "3") {
        display_data = (
          <DosenPT
            idSms={this.state.id_sms}
            idSp={this.state.id_sp}
            displayProdi={this.state.displayProdi}
            resetProdi={this.state.resetProdi}
            handleCallbackDisplayProdi={this.handleCallbackDisplayProdi}
            handleCallbackResetProdi={this.handleCallbackResetProdi}
            handleCallbackSearch={this.handleCallbackSearch}
          />
        );
      }
    }

    // else if(menu === "4"){
    //     display_data = <PengabdianPT/>;
    // }
    let listProdi = <></>;
    if (this.state.display === true) {
      if (this.state.dataProd.length > 0) {
        let dataSms = [];
        this.state.dataProd.map((v, i) => {
          dataSms.push(
            <div
              onClick={(e) => this.onClickSelectProdi(v.id_sms, v.nama)}
              style={{
                background: "#fff",
                padding: "10px",
                color: "#2c2c2c",
                borderBottom: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              {v.nama}
            </div>
          );
        });
        listProdi = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
            }}
          >
            {dataSms}
          </div>
        );
      } else {
        listProdi = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              background: "#fff",
              padding: "10px",
              color: "#ccc",
              borderBottom: "1px solid #ccc",
              cursor: "pointer",
              fontStyle: "italic",
            }}
          >
            Data prodi tidak ditemukan.
          </div>
        );
      }
    }
    let resetProdi = <></>;
    if (this.state.name_sms !== "") {
      resetProdi = (
        <i
          onClick={(e) => this.onClickResetProdi(e)}
          className="flaticon-close text-dark"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "25px",
            bottom: "10px",
            cursor: "pointer",
          }}
        ></i>
      );
    }
    if (this.state.loadingProdi === true) {
      resetProdi = (
        <i
          className="ml-3 spinner spinner-black"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "45px",
            bottom: "20px",
          }}
        ></i>
      );
    }
    let loadingSearch = <></>;
    if (this.state.loadingSearch === true) {
      loadingSearch = (
        <i
          className="spinner spinner-black"
          style={{ marginRight: "20px" }}
        ></i>
      );
    }

    let searchComponent = <></>;
    if (sessiondata.i_idrole === 6) {
      searchComponent = (
        <>
          <div className="col-md-6 text-white" style={{ textAlign: "center" }}>
            <h1
              className="font-weight"
              style={{ marginTop: "5.5%", marginRight: "2%" }}
            >
              {sessiondata.i_nmunit}
            </h1>
          </div>
          <div className="col-md-6 text-white">
            <div className="row">
              <div className="col-md-12">
                <span>Tampilkan Data </span>
                <i
                  className="flaticon2-dashboard text-dark"
                  style={{
                    position: "absolute",
                    zIndex: 2,
                    left: "25px",
                    bottom: "10px",
                  }}
                ></i>
                <select
                  name="display"
                  className={`form-control form-control-lg form-control-solid `}
                  style={{ marginTop: "1.8%", paddingLeft: "40px" }}
                  onChange={(e) => this.onChangeMenu(e, "menu")}
                >
                  <option value="1">Semua</option>
                  <option value="2">Mahasiswa</option>
                  <option value="3">Dosen</option>
                  {/* <option value="4">Pengabdian</option> */}
                </select>
              </div>
            </div>
          </div>
        </>
      );
    } else if (sessiondata.i_idrole === 3) {
      searchComponent = (
        <>
          <div className="col-md-5 text-white" style={{ textAlign: "center" }}>
            <h1
              className="font-weight"
              style={{ marginTop: "5.5%", marginRight: "2%" }}
            >
              {sessiondata.i_nmunit}
            </h1>
          </div>
          <div className="col-md-7 text-white">
            <div className="row">
              <div className="col-md-4">
                <span>Tampilkan Data </span>
                <i
                  className="flaticon2-dashboard text-dark"
                  style={{
                    position: "absolute",
                    zIndex: 2,
                    left: "25px",
                    bottom: "10px",
                  }}
                ></i>
                <select
                  name="display"
                  className={`form-control form-control-lg form-control-solid `}
                  style={{ marginTop: "1.8%", paddingLeft: "40px" }}
                  onChange={(e) => this.onChangeMenu(e, "menu")}
                >
                  <option value="1">Semua</option>
                  <option value="2">Mahasiswa</option>
                  <option value="3">Dosen</option>
                  {/* <option value="4">Pengabdian</option> */}
                </select>
              </div>
              <div className="col-md-6">
                <span>Pencarian Program Studi </span>
                <i
                  className="flaticon-search text-dark"
                  style={{
                    position: "absolute",
                    zIndex: 2,
                    left: "25px",
                    bottom: "10px",
                  }}
                ></i>
                {resetProdi}
                <input
                  type="text"
                  style={{ marginTop: "1.8%", paddingLeft: "40px" }}
                  // value={keyword}
                  // onChange={(e) => this.onInputChangeName(e, 'keyword')}
                  className={`form-control form-control-lg form-control-solid `}
                  placeholder="Masukan keyword : Nama prodi.."
                  onChange={(e) => this.onChangeProdi(e)}
                  autoComplete="off"
                  name="id_sms"
                  value={this.state.name_sms}
                />
                {listProdi}
              </div>
              <div className="col-md-2 text-center">
                <Button
                  onClick={(e) => this.onClickSearchProdi(e)}
                  variant="light"
                  style={{ marginTop: "25px", padding: "12px", width: "100%" }}
                >
                  {loadingSearch} Cari
                </Button>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      if (this.state.menu_display === true) {
        searchComponent = (
          <>
            <div
              className="col-md-5 text-white"
              style={{ textAlign: "center" }}
            >
              <h1
                className="font-weight"
                style={{ marginTop: "5.5%", marginRight: "2%" }}
              >
                {this.state.name_sp}
              </h1>
            </div>
            <div className="col-md-7 text-white">
              <div className="row">
                <div className="col-md-4">
                  <span>Tampilkan Data </span>
                  <i
                    className="flaticon2-dashboard text-dark"
                    style={{
                      position: "absolute",
                      zIndex: 2,
                      left: "25px",
                      bottom: "10px",
                    }}
                  ></i>
                  <select
                    name="display"
                    className={`form-control form-control-lg form-control-solid `}
                    style={{ marginTop: "1.8%", paddingLeft: "40px" }}
                    onChange={(e) => this.onChangeMenu(e, "menu")}
                  >
                    <option value="1">Semua</option>
                    <option value="2">Mahasiswa</option>
                    <option value="3">Dosen</option>
                    {/* <option value="4">Pengabdian</option> */}
                  </select>
                </div>
                <div className="col-md-6">
                  <span>Pencarian Program Studi </span>
                  <i
                    className="flaticon-search text-dark"
                    style={{
                      position: "absolute",
                      zIndex: 2,
                      left: "25px",
                      bottom: "10px",
                    }}
                  ></i>
                  {resetProdi}
                  <input
                    type="text"
                    style={{ marginTop: "1.8%", paddingLeft: "40px" }}
                    // value={keyword}
                    // onChange={(e) => this.onInputChangeName(e, 'keyword')}
                    className={`form-control form-control-lg form-control-solid `}
                    placeholder="Masukan keyword : Nama prodi.."
                    onChange={(e) => this.onChangeProdi(e)}
                    autoComplete="off"
                    name="id_sms"
                    value={this.state.name_sms}
                  />
                  {listProdi}
                </div>
                <div className="col-md-2 text-center">
                  <Button
                    onClick={(e) => this.onClickSearchProdi(e)}
                    variant="light"
                    style={{
                      marginTop: "25px",
                      padding: "12px",
                      width: "100%",
                    }}
                  >
                    {loadingSearch} Cari
                  </Button>
                </div>
              </div>
            </div>
          </>
        );
      } else {
        searchComponent = (
          <div className="col-md-12 text-white">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            &nbsp;Loading ...
            <LinearProgress color="secondary" variant="query" />
          </div>
        );
      }
    }
    return (
      <>
        <Card
          style={{ marginBottom: "1%" }}
          ref={(el) => {
            if (el) {
              el.style.setProperty("overflow", "initial", "important");
            }
          }}
        >
          <div
            className="row row-paddingless"
            style={{
              backgroundImage: `url(${bgImage})`,
              padding: "2%",
              textAlign: "",
            }}
          >
            {searchComponent}
          </div>
        </Card>
        <CardContent style={{ padding: "0px" }}>{display_data}</CardContent>
        <br />
      </>
    );
  }
}
export default PT;
